// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';

import { SvgIcon } from '../../../lib/base';

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
type Props = any;

export default (paths: Array<React.ReactElement>, viewBox?: string) => {
  function Icon(props: Props): React.ReactElement {
    return (
      <SvgIcon {...props} viewBox={viewBox ?? '0 0 24 24'}>
        {paths}
      </SvgIcon>
    );
  }

  return Icon;
};
